import React, {useEffect, useState} from "react";
import Modal from "react-modal";
import axios from "axios";

const isTrue = (value) => (value === 1 || value === "1");

const RevenueDialog = (props) => {

  const [isFirst, setIsFirst] = useState(true);
  const [adUnits, setAdUnits] = useState(null);
  const {open, onClose, onApply} = props;

  useEffect(() => {
    setIsFirst(false);
    getAdUnitInfo();
  }, [])


  /**
   * 광고단위 리스트 호출 및 셋팅
   */
  function getAdUnitInfo() {
    axios({
      url: (`${appInfo.manageUrl}/revenue/adunits/adfit.json`),
      method: 'get'
    }).then(res => {

      if (res.data.data) {
        const {pc_content_middle, mo_content_middle} = res.data.data.list;

        if (pc_content_middle && mo_content_middle && isTrue(pc_content_middle.activate) && isTrue(mo_content_middle.activate))
          setAdUnits({pc: pc_content_middle, mobile: mo_content_middle});
      }
    }).catch(error => {
      console.error('res : ', error);
    })
  }

  /**
   * 광고태그 삽입
   */
  function handleApplyRevenue(pc, mobile) {
    onApply(`<figure data-ke-type="revenue" data-ad-vendor="adfit" data-ad-id-pc=${pc.id} data-ad-id-mobile=${mobile.id} contentEditable="false" class="ad-wp"></figure>`);
  }

  return <Modal
    ariaHideApp={false}
    closeTimeoutMS={200}
    className={'editor_layer_type3'}
    isOpen={open}
    onRequestClose={onClose}
  >
    <div style={{display: {none: isFirst}}}>
      <div className="inner_editor_layer">
        <div className="cont_layer">
          <strong className="tit_popup">광고</strong>

          {adUnits && <div className="box_layer">
            <dl>
              <dt>PC</dt>
              <dd>{adUnits.pc.type}</dd>
            </dl>
            <dl>
              <dt>모바일</dt>
              <dd>{adUnits.mobile.type}</dd>
            </dl>
          </div>
          }

          <p className="desc_editor"><span className="ico_setting">설정 </span> > 수익 > 광고 관리의 ‘본문 중간(에디터)’로 광고를 설정하세요.</p>
        </div>
        <div className="fld_btn">
          <button type="button" className="btn" onClick={onClose}>취소</button>
          <button type="submit" className="btn btn-default" onClick={() => handleApplyRevenue(adUnits.pc, adUnits.mobile)}>확인</button>
        </div>
      </div>
    </div>
  </Modal>
}


export default RevenueDialog;
